// Function to run the desired code
function processElements() {
    var current_url = window.location.href;
      if(current_url == 'https://tryregift.com/collections/all?anonymous-creator') {
         const liElements = document.querySelectorAll('li.grid__item');

          liElements.forEach(function(li) {
              // Select child div elements
              const divElements = li.querySelectorAll('div');
              
              // Flag to check if any div child has the class "links_for_metaobject"
              let hasClass = false;
              
              divElements.forEach(function(div) {
                  if (div.classList.contains('anonymous_creator')) {
                      hasClass = true;
                  }
              });
              
              // If no div child has the class "links_for_metaobject"
              if (!hasClass) {
                  // Add the desired class to the li element
                  li.classList.add('anonymous_extra_pro_hide');
              }
          });
      }
  
let url = window.location.origin + window.location.pathname;
 

  if(current_url != 'https://tryregift.com/collections/all?anonymous-creator' && url != 'https://tryregift.com/collections/shop-all' ) {
         const liElements = document.querySelectorAll('li.grid__item');

          liElements.forEach(function(li) {
              // Select child div elements
              const divElements = li.querySelectorAll('div');
              
              // Flag to check if any div child has the class "links_for_metaobject"
              let hasClass = false;
              
              divElements.forEach(function(div) {
                  if (div.classList.contains('anonymous_creator_active')) {
                      hasClass = true;
                  }
              });
              
              // If no div child has the class "links_for_metaobject"
              if (hasClass) {
                  // Add the desired class to the li element
                  li.classList.add('anonymous_extra_pro_hide');
              }
          });
      }

  

    // Check if the body has the attribute template="consigner"
    if (document.body.getAttribute('template') === 'consigner') {
        const liElements = document.querySelectorAll('li.grid__item');
    
        liElements.forEach(function(li) {
            // Select child div elements
            const divElements = li.querySelectorAll('div');
    
            // Flag to check if any div child has the class "anonymous_creator"
            let hasClass = false;
    
            divElements.forEach(function(div) {
                if (div.classList.contains('anonymous_creator')) {
                    hasClass = true;
                }
            });
    
            // If no div child has the class "anonymous_creator"
            if (hasClass) {
                // Add the desired class to the li element
                li.classList.add('anonymous_extra_pro_hide');
            }
        });
    }
}

// Add scroll event listener to the window
window.addEventListener('scroll', processElements);

// Optionally, run the function once on page load
processElements();


